import { render } from "./newsManage.vue?vue&type=template&id=4bd13036"
import script from "./newsManage.vue?vue&type=script&lang=js"
export * from "./newsManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__